import { AIOutcome } from '@weave/schema-gen-ts/dist/shared/phone/v1/callrecord/enums.pb';
import { i18next } from '@frontend/i18n';
import {
  getAiOutcomeIconWithTooltip as _getAiOutcomeIconWithTooltip,
  getAiOutcomeIcon as _getAiOutcomeIcon,
  OUTCOME_MAPPING,
} from '@frontend/phone-ui';

export const getAiOutcomeIcon = ({ outcome, useTooltip = false }: { outcome: AIOutcome; useTooltip?: boolean }) => {
  let _outcome: (typeof OUTCOME_MAPPING)[keyof typeof OUTCOME_MAPPING] | undefined;
  let tooltip = '';
  const getIcon = useTooltip ? _getAiOutcomeIconWithTooltip : _getAiOutcomeIcon;

  if (outcome === AIOutcome.AI_OUTCOME_END_CALL) {
    _outcome = OUTCOME_MAPPING.SUCCESS;
    tooltip = i18next.t('AI Receptionist successfully assisted the patient');
  } else if (outcome === AIOutcome.AI_OUTCOME_FATAL) {
    _outcome = OUTCOME_MAPPING.FATAL;
    tooltip = i18next.t('AI Receptionist failed to answer this call.');
  } else if (outcome === AIOutcome.AI_OUTCOME_ROUTE_MISSED) {
    _outcome = OUTCOME_MAPPING.ROUTE_MISSED;
    tooltip = i18next.t('Your office missed the transfer from the AI Receptionist. The caller may need assistance.');
  } else if (outcome === AIOutcome.AI_OUTCOME_ROUTE_TRANSFERRED) {
    _outcome = OUTCOME_MAPPING.ROUTE_ANSWERED;
    tooltip = i18next.t('AI Receptionist transferred the call to your office.');
  } else if (outcome === AIOutcome.AI_OUTCOME_TEXT_HANDOFF) {
    _outcome = OUTCOME_MAPPING.TEXT_HANDOFF;
    tooltip = i18next.t('AI Receptionist continued the conversation over text.');
  } else if (outcome === AIOutcome.AI_OUTCOME_INCOMPLETE) {
    _outcome = OUTCOME_MAPPING.INCOMPLETE;
    tooltip = i18next.t('Caller hung up before AI Receptionist could determine the outcome.');
  }

  return _outcome ? getIcon({ outcome: _outcome, tooltip }) : null;
};
